module.exports = __webpack_public_path__ + "static/media/course-food.22a1a1ba.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/course-food.jpg
 ** module id = 504
 ** module chunks = 0
 **/